module.exports = __webpack_public_path__ + "static/media/paint-brush-alt.f3c4e246.svg";